<template>
  <v-layout row wrap style="flex:1 0;overflow:auto;align-items:flex-start;">
    <v-flex xs12 class="inline-block px-2">
      <v-text-field hide-details  :label="$t('Admin.Glider.Form.Key')" v-model="gli_key"/>
      <v-text-field hide-details  :label="$t('Admin.Glider.Form.Alias')" v-model="gli_libelle"/>
      <v-select hide-details  :items="models" :label="$t('Admin.Glider.Form.Model')" v-model="gli_fabricant"></v-select>
      <v-select hide-details 
        :items="enseignes"
        item-text="ENS_LIBELLE"
        item-value="ENS_ID"
        :label="$t('Admin.Glider.Form.Owner')"
        v-model="ens_id"
      ></v-select>
      <v-menu
        :close-on-content-click="false"
        v-model="showDate"
        :nudge-right="40"
        lazy
        transition="scale-transition"
        offset-y
        full-width
        max-width="310px"
        min-width="310px"
      >
        <v-text-field hide-details 
          slot="activator"
          :label="$t('Admin.Glider.Form.ManufacturingDate')"
          append-icon="mdi-calendar"
          readonly
        ></v-text-field>
        <v-date-picker no-title @input="showDate = false"></v-date-picker>
      </v-menu>
      <v-text-field hide-details  :label="$t('Admin.Glider.Form.SerialNumber')" v-model="gli_nserie"/>
      <!--<v-text-field hide-details  :label="$t('Admin.Glider.Form.Manufacturer')" value="Alseamar" readonly/>-->
      <v-select hide-details :items="[700,1000]" :label="$t('Admin.Glider.Form.MaxDepth')" v-model="gli_pmax"></v-select>            
      <v-menu
        :close-on-content-click="false"
        v-model="showStatus"
        :nudge-right="40"
        lazy
        transition="scale-transition"
        offset-y
        full-width
        max-width="310px"
        min-width="310px"
      >
        <v-text-field hide-details 
          slot="activator"
          :label="$t('Admin.Glider.Form.Status')"
          :prepend-icon="gta_icon"
          append-icon="mdi-menu-down"
          readonly
          v-model="gta_libelle"
        ></v-text-field>
        <v-list>
          <v-list-tile
            v-for="statu in status"
            :key="statu.GTA_ID"
            @click.prevent="showStatus = false;gta_libelle = statu.GTA_LIBELLE;gta_icon = statu.icon"
          >
            <v-list-tile-title>{{statu.GTA_LIBELLE}}</v-list-tile-title>
            <v-list-tile-action>
              <v-spacer/>
              <v-icon :color="statu.iconColor">{{statu.icon}}</v-icon>
            </v-list-tile-action>
          </v-list-tile>
        </v-list>
      </v-menu>      
    </v-flex>    
  </v-layout>        
</template>

<script lang="ts">
import Vue from 'vue'
import Component from 'vue-class-component'

@Component({
  name: 'AdminGliderForm'
})
export default class AdminGliderForm extends Vue {
    
  public showDate: Boolean = false
  public showStatus: Boolean = false
  public gta_libelle: String = ''
  public gta_icon: String = ''

  created() {        
    this.$store.myActions.ENSEIGNE_ENSURE_LIST()      
  }

  get modified() {
    return this.$store.myGetters.modifiedAdmGlider
  }

  get models() {
    return ['SXP', 'DXP']
  }

  get enseignes() {
    return this.$store.myGetters.enseignes
  }

  get status() {
    return [
      { GTA_LIBELLE: 'At Sea', GTA_ID: 1, icon: 'mdi-waves', iconColor: '#0000ff' },
      { GTA_LIBELLE: 'In transit', GTA_ID: 2, icon: 'mdi-airplane-takeoff', iconColor: '#aa2aff' },
      { GTA_LIBELLE: 'In repair', GTA_ID: 3, icon: 'mdi-hospital', iconColor: '#ff0000' },
      { GTA_LIBELLE: 'In preparation', GTA_ID: 4, icon: 'mdi-wrench', iconColor: '#ffe22b' },
      { GTA_LIBELLE: 'Ready to go', GTA_ID: 5, icon: 'mdi-thumb-up', iconColor: '#00ff00' },
      { GTA_LIBELLE: 'Lost', GTA_ID: 6, icon: 'mdi-cancel', iconColor: '#000000' }
    ]
  }

  get gli_key() {
    return this.$store.myGetters.modifiedAdmGlider.GLI_KEY!
  }
  set gli_key(value: string) {
    this.$store.myActions.GLIDER_UPDATE_MODIFIED_ADM({
      GLI_KEY: value
    })
  }

  get gli_libelle() {
    return this.modified.GLI_LIBELLE!
  }
  set gli_libelle(value: string) {
    this.$store.myActions.GLIDER_UPDATE_MODIFIED_ADM({
      GLI_LIBELLE: value
    })
  }

  get ens_id() {
    return this.modified.ENS_ID!
  }
  set ens_id(value: number) {
    this.$store.myActions.GLIDER_UPDATE_MODIFIED_ADM({
      ENS_ID: value
    })
  }


  get gli_fabricant() {
    return this.modified.GLI_FABRICANT!
  }
  set gli_fabricant(value: string) {
    this.$store.myActions.GLIDER_UPDATE_MODIFIED_ADM({
      GLI_FABRICANT: value
    })
  }
  

  get gli_datefab() {
    return this.modified.GLI_DATFAB!
  }
  set gli_datefab(value: Date) {
    this.$store.myActions.GLIDER_UPDATE_MODIFIED_ADM({
      GLI_DATFAB: value
    })
  }
  get gli_datefabformated() {
    if (this.gli_datefab && this.gli_datefab.toISOString) {
      return this.formatDate(this.gli_datefab.toISOString().split('T')[0])
    } else {
      return null
    }
  }

  get gli_nserie() {
    return this.$store.myGetters.modifiedAdmGlider.GLI_NSERIE!
  }
  set gli_nserie(value: string) {
    this.$store.myActions.GLIDER_UPDATE_MODIFIED_ADM({
      GLI_NSERIE: value
    })
  }

  get gli_pmax() {
    return this.$store.myGetters.modifiedAdmGlider.GLI_PMAX!
  }
  set gli_pmax(value: number) {
    this.$store.myActions.GLIDER_UPDATE_MODIFIED_ADM({
      GLI_PMAX: value
    })
  }

  

  get gta_id() {
    //TODO modifier
    return this.$store.myGetters.modifiedAdmGlider.ENS_ID!
  }
  set gta_id(value: number) {
    //TODO modifier
    this.$store.myGetters.modifiedAdmGlider.ENS_ID = value
  }

  formatDate(date: String) {
    if (!date) return null

    const [year, month, day] = date.split('-')
    return `${day}/${month}/${year}`
  }

}
</script>

<style scope>
.v-expansion-panel__header {
  background-color: #f5f5f5;
  padding-top: 0px;
  padding-bottom: 0px;
}
</style>